import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import DictateButton from './DictateButton';

export default function QuickNoteFab() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);
  const [savedFlash, setSavedFlash] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!text.trim()) return;
    setSaving(true);
    try {
      await api.post('/private-notes', { content: text.trim(), project_id: null, folder_id: null });
      setText('');
      setSavedFlash(true);
      setTimeout(() => setSavedFlash(false), 1500);
      setTimeout(() => setOpen(false), 900);
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <button
        className="fab fab-note"
        title="Capture rapide (noter quelque chose)"
        onClick={() => setOpen((v) => !v)}
        style={{ background: 'var(--c-btn-revoir)' }}
      >
        ✎
      </button>
      {open && (
        <div className="quick-note-panel" onClick={(e) => e.stopPropagation()}>
          <div className="floating-head" style={{ background: 'var(--c-btn-revoir)' }}>
            <span>Capture rapide</span>
            <button className="icon-btn" onClick={() => setOpen(false)} style={{ color: '#fff' }}>
              ×
            </button>
          </div>
          <form onSubmit={submit} style={{ padding: 12 }}>
            <div className="card-meta" style={{ marginBottom: 6 }}>
              Cette note arrive dans ton{' '}
              <Link to="/perso" onClick={() => setOpen(false)}>
                Espace perso
              </Link>
              {' '}(transversal, pas lié à un projet).
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
              <textarea
                rows={4}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Une idée, une question, un rappel…"
                style={{
                  flex: 1,
                  padding: 10,
                  border: '1px solid var(--c-border)',
                  borderRadius: 6,
                  background: 'var(--c-bg)',
                  resize: 'vertical',
                }}
                autoFocus
              />
              <DictateButton value={text} onChange={setText} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
              {savedFlash && <span className="card-meta">✓ Enregistré</span>}
              <button className="btn btn-primary" disabled={saving}>
                {saving ? 'Enregistrement…' : 'Noter'}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
